(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
  
    observer.unobserve(productRecommendationsSection);
  
    const url = productRecommendationsSection.dataset.url;
  
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
  
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
  
          setTimeout(() => {
            $('.related-slider').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              rows: 0,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 500,
                  settings: {
                    slidesToShow: 1
                  }
                }
              ]
            });
          }, 0);
        }
      })
      .catch(e => {
        console.error(e);
      });
  };
  
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 200px 0px'
  });
  
  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
